import logger from '../../utils/logger';
import { toNumber } from '../../utils/numbers';
import {
  BatchMode,
  MeteredMaterialType,
} from '../../constants/MaterialModels';

/**
 * Auto cut off adjustment for metered materials
 * This function dynamically adjusts the cut-off value of a metered material (admixture)
 * based on the actual vs. target weight. It helps fine-tune the dosing process
 * by correcting deviations to improve accuracy over time
 *
 * @param rootStore
 * @param {MeteredDataToBatch} meteredData
 * @param {number} weight
 */
export const autoCutOffAdjustmentForMetered = (rootStore, meteredData, weight) => {
  const { materialStore, batchStore } = rootStore;
  const { material, pump, mft, isFeedInterrupted } = meteredData;
  const materialDetails = materialStore.materialDetails[material.materialDetailId];
  const hasAutoAdjustment = materialDetails?.autoCutOff && materialDetails?.autoCutOffAdjustment;
  const isValidMode = materialDetails?.batchMode === BatchMode.Auto;
  const isAdmixture = materialDetails?.type === MeteredMaterialType.Admixture;
  const isDeviceHeld = batchStore.isHoldFeedDevice(pump.id);

  if (!hasAutoAdjustment || !isValidMode || !isAdmixture || isDeviceHeld || isFeedInterrupted) {
    return;
  }

  const target = toNumber(mft, 2);
  const tolerance = batchStore.getTolerance(materialDetails, target);
  const isUnderTarget = weight + tolerance?.under < target;
  const isOverTarget = weight - tolerance?.over > target;

  logger.log('autoCutOff::', material.code, pump.description, weight, target,
    'tolerance', tolerance, 'isUnder:', isUnderTarget, 'isOver:', isOverTarget);

  if (isUnderTarget || isOverTarget) {
    const newCutOffData = {
      cutOff: isUnderTarget
        ? materialDetails.cutOff - materialDetails.autoCutOffAdjustment
        : materialDetails.cutOff + materialDetails.autoCutOffAdjustment,
    };

    logger.log('autoCutOff::', material.code, pump.description, weight, target,
      'new cutOff:', materialDetails.cutOff, '->', newCutOffData.cutOff);

    if (!batchStore.isDemo && !batchStore.replayMode && !batchStore.isTestMode) {
      materialStore.saveMaterialDetail(material, { ...materialDetails, ...newCutOffData }, true);
    }
  }

};
